import classNames from "classnames";

type InputLabelProps = {
    label?: string;
    className?: string;
    required?: boolean;
};

const InputLabel = ({ label, className, required }: InputLabelProps) => {
    if (!label) return null;

    return (
        <label className={classNames("form-label fs-7", className)}>
            {label}
            {required && <small className="text-danger"> *</small>}
        </label>
    );
};

export default InputLabel;
